module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', [_c('div', {
    staticClass: "wrapper bg-light lter b-b"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-bg btn-default",
    attrs: {
      "disabled": !_vm.hasPreviousPage,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.previousPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-bg btn-default",
    attrs: {
      "disabled": !_vm.hasNextPage,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-toolbar"
  }, [_c('div', {
    staticClass: "pull-left m-t-xs m-l"
  }, [_vm._v("\n          Página " + _vm._s(_vm.pagination.atualPage) + " de " + _vm._s(_vm.pagination.totalPages) + "\n        ")])])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "msg"
  }, [_vm._v("Carregando...")]) : (_vm.mensagens.length < 1) ? _c('div', {
    staticClass: "msg"
  }, [_vm._v("Nenhum e-mail a ser mostrado")]) : _c('ul', {
    staticClass: "list-group list-group-lg no-radius m-b-none m-t-n-xxs"
  }, _vm._l((_vm.mensagens), function(mail) {
    return _c('item-email', {
      key: mail.id,
      attrs: {
        "mail": mail
      }
    })
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc3bc86a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/contatos/components/ListaEmails.vue
// module id = 1853
// module chunks = 17